import React from 'react';
import { Card } from 'reactstrap';
import { OtherWidgetsCharts } from './WidgetsCharts';

const SummaryCard = ({ item }) => {
	return (
		<Card className='card-height-100'>
			<div className='d-flex p-3'>
				<div className='flex-grow-1'>
					<h3 className='m-0 fw-bold'>
						{item.value} {item.unit}
					</h3>
					<h5 className='mb-2 text-muted'>{item.title}</h5>
					<div>
						<span className='mb-0 text-muted fw-bold fs-11'>
							{item.difference} {item.unit}
						</span>
						<span className='mb-0 text-muted fst-italic fs-10'>
							{' '}
							diferencia semana anterior
						</span>
					</div>
				</div>
				<div className='flex-shrink-0 align-self-center'>
					<OtherWidgetsCharts
						dataColors={item.dataColors}
						seriesData={item.series}
					/>
				</div>
			</div>
		</Card>
	);
};

export default SummaryCard;
